import Router from 'preact-router';
import {
	h,
	render,
	Component
} from 'preact';
import App from './components/App';
import Rules from './components/Rules';
import Faq from './components/Faq';
import PrivacyPolicy from './components/PrivacyPolicy';
import TermsOfUse from './components/TermsOfUse';
import './style';
require('preact/debug');

export default class Main extends Component {
	render() {
		return (<Router >
			<App path="/" />
			<Rules path="/rules" />
			<Faq path="/faq" />
			<PrivacyPolicy path="/privacy" />
			<TermsOfUse path="/terms" />
		</Router>
		);
	}
}


// WEBPACK FOOTER //
// ./index.js